angular.module('app', [
	'app.api',
	'stripe',
	'FullpageScroll',
	'checklist-model',
	'dndLists',
	'angular.filter',
	'ngMessages',
	'angularGrid',
	'ui.bootstrap',
	'duScroll',
	'ui.router',
	'angularFileUpload',
	'jcs-autoValidate',
	'ngToast'
])
	.config(function($locationProvider, $stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise('/');
		$locationProvider.html5Mode(true);
		// Stripe.setPublishableKey('pk_test_fQegUFywTscUqrC80Lql0SMg');
	})
	.run(function($rootScope, $location){
		$rootScope.$on('$stateChangeSuccess', function(){
			if($location.path() !== '/'){
				$rootScope.notMain = true;
			}else{
				$rootScope.notMain = false;
			}
		});
	})
	.value('duScrollDuration', 1000)
	.directive('compareTo', function(){
		return {
      require: 'ngModel',
      scope: {
        otherModelValue: '=compareTo'
      },
      link: function(scope, element, attributes, ngModel) {

        ngModel.$validators.compareTo = function(modelValue) {
            return modelValue === scope.otherModelValue;
        };

        scope.$watch('otherModelValue', function() {
            ngModel.$validate();
        });
      }
	  };
	})
	.directive('navBarEffect', function ($window) {
	    return function(scope) {
	        angular.element($window).bind('scroll', function() {
						if (this.scrollY >= $window.innerHeight/2){
							scope.navEffect = true; //show nav background
						}else{
							scope.navEffect = false;
						}
	          scope.$apply();
	        });
	    };
	});
